import gql from "graphql-tag";

export const notificationFields = gql`
  fragment NotificationFields on Notification {
    id
    type
    name
    severity
    status
    triggeringEntities
    insertedAt
    updatedAt
    body
    title
    automatedResolution
  }
`;

export const NOTIFICATIONS = gql`
  query UserNotifications(
    $userId: ID!
    $organizationId: ID
    $severity: String
    $severities: [String]
    $status: String
    $statuses: [String]
    $type: String
    $types: [String]
  ) {
    userNotifications(
      userId: $userId
      organizationId: $organizationId
      severity: $severity
      severities: $severities
      status: $status
      statuses: $statuses
      type: $type
      types: $types
      sort: "insertedAt"
    ) {
      ...NotificationFields
      organization {
        id
        name
        type
        subtype
      }
      user {
        id
        firstName
        lastName
      }
      bulkNotification {
        id
        name
        status
        workflow
        notes
        insertedAt
        updatedAt
        organization {
          id
          name
        }
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
  ${notificationFields}
`;

export const NOTIFICATION_DETAILS = gql`
  query NotificationDetails($id: ID!, $markAsRead: Boolean) {
    userNotification(id: $id, markAsRead: $markAsRead) {
      ...NotificationFields
      organization {
        id
        name
        type
        subtype
      }
      events {
        type
        name
        timestamp
        data
      }
    }
  }
  ${notificationFields}
`;

export const NOTIFICATION_FROM_SIBLING = gql`
  query UserNotificationFromSibling($id: ID!) {
    userNotification(id: $id, markAsRead: true) {
      id
      notificationSiblings(type: "application") {
        id
        name
        triggeringEntities
        organization {
          id
        }
      }
    }
  }
`;

export const DISMISS_NOTIFICATION = gql`
  mutation DismissNotification($id: ID!) {
    updateNotification(id: $id, status: "dismissed") {
      id
      status
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation UpdateNotification(
    $id: ID!
    $status: String
    $reason: String
    $action: String
  ) {
    updateNotification(
      id: $id
      status: $status
      reason: $reason
      action: $action
    ) {
      id
      status
    }
  }
`;

export const DISMISS_ALL_NOTIFICATIONS = gql`
  mutation dismissNotifications {
    dismissNotifications
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  query MarkNotificationRead($id: ID!) {
    userNotification(id: $id, markAsRead: true) {
      id
      status
    }
  }
`;

export const PENDING_BULK_NOTIFICATIONS = gql`
  query PendingBulkNotifications(
    $organizationId: ID
    $status: String
    $name: String
  ) {
    bulkNotifications(
      organizationId: $organizationId
      status: $status
      name: $name
    ) {
      id
      name
      type
      severity
      status
      workflow
      notes
      insertedAt
      updatedAt
      automatedResolution
      organization {
        id
        name
      }
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
`;
